import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { IMPORT_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IImportUpload } from '~/Models/DTO/Import.model';

export const useRequestImportCustomerData = ({
  importId,
  showProblems,
}: {
  importId: string;
  showProblems: boolean;
}) => {
  const { currentProvider } = useProvider();

  const { isLoading, isFetching, error, data, refetch } = useQuery<IImportUpload, IErrorResponse>(
    [REQUEST_ACTIONS.GET_INVOICE_DOWNLOAD_URL, currentProvider?.uuid, importId, showProblems],
    () =>
      requestReactQuery<IImportUpload>({
        url: IMPORT_URLS.IMPORT_CUSTOMERS_DATA,
        config: { method: 'GET' },
        params: {
          providerId: currentProvider?.uuid,
          importId,
          onlyWithErrors: showProblems,
        },
      }),
    {
      enabled: false,
    },
  );

  return {
    isCustomerDataLoading: isLoading,
    isCustomerDataFetching: isFetching,
    customerDataError: error,
    customerData: data,
    refetchImportCustomerData: refetch,
  };
};
